import { Formatter, Spinner } from 'shared'
import { ParkApi, Model } from 'api'
import ParkReservationSlots from './ParkReservationSlots'
import ParkReservationCalendar from './ParkReservationCalendar'
import ParkReservationDetails from './ParkReservationDetails'
import ParkServiceSelector from './ParkServiceSelector'
import { useEffect, useRef, useState } from 'react'

const ParkReservationBlock = ({ base, park, reloadSmartButtons, subroute }) => {
  // State
  const [state, setState] = useState({ date: null, time: null, timeSlots: null, workflowComplete: false })

  // Consts
  const prevPropsRef = useRef({})
  const loadedDateRef = useRef(null)
  const loadedServiceIdRef = useRef(null)

  // Hooks
  useEffect(() => {
    loadTimeslots()
    handleSubrouteChange(prevPropsRef.current)
  }, [])

  useEffect(() => {
    handleSubrouteChange(prevPropsRef.current)
    prevPropsRef.current = { subroute }
  }, [subroute])

  // Custom Methods
  const cancelSlot = async (timeSlot) => {
    let { date, serviceId } = state
    await ParkApi.cancelTimeSlot(park, timeSlot)
    reloadSmartButtons()
    EventApi.reset('mineGrouped')
    const timeSlots = await ParkApi.loadTimeSlotsForDate(park, date, serviceId)
    setState(prev => ({ ...prev, timeSlots }))
  }

  const handleSubrouteChange = async (prevProps) => {
    let prevSubroute = prevProps.subroute
    let currSubroute = subroute
    if (prevSubroute == currSubroute) return

    let [ currServiceId, currDateStr, currTime ] = Model.extractSubrouteArgs(currSubroute)
    let currDate = currDateStr && moment(currDateStr)

    if (currServiceId == 'NA') currServiceId = null

    setState(prev => ({ ...prev, date: currDate, time: currTime, timeSlots: null, serviceId: currServiceId }))

    if (currDate && (loadedDateRef.current !== currDate || loadedServiceIdRef.current !== currServiceId)) {
      loadedDateRef.current = currDate
      loadedServiceIdRef.current = currServiceId
      const slots = await ParkApi.loadTimeSlotsForDate(park, currDate, currServiceId)
      setState(prev => ({ ...prev, timeSlots: slots }))
    }
  }

  const loadTimeslots = () => {
    if (park.fully_reserved_dates == undefined)
      ParkApi.show(park.id)
  }

  const loadWorflowStatus = async (park) => {
    if (!state.workflowComplete) {
      let workflowStatus = await ParkApi.getWorkflowStatus(park)
      setState(prev => ({ ...prev, workflowComplete: workflowStatus }))
    }
  }

  const reserveSlot = async (timeSlot, {tickets, serviceId, success} = {}) => {
    let timeSlots = await ParkApi.reserveTimeSlot(park, timeSlot, tickets, serviceId)
    if (timeSlots) setState(prev => ({ ...prev, timeSlots }))
    reloadSmartButtons()
    EventApi.reset('mineGrouped')
    success && success()
  }

  // render
  let { date, time, timeSlots, serviceId, workflowComplete } = state
  let service = park.getService(serviceId)

  loadWorflowStatus(park)

  let hhmm, slot
  if (time) {
    hhmm = Formatter.militaryToHHMM(time)
    slot = timeSlots && timeSlots.find(ts => ts.time == hhmm)
  }

  return (
    <div>
    {
      workflowComplete ?
        time ?
          slot && <ParkReservationDetails {...{park, base, subroute, service, serviceId, date, time, slot}} reserve={reserveSlot} />
          :
          park.usesSimpleReservation || service ?
            <>
              <ParkReservationCalendar {...{park, base, date, service, serviceId}} />
              <ParkReservationSlots {...{park, base, subroute, service, serviceId, date, timeSlots}} reserve={reserveSlot} cancel={cancelSlot} />
            </>
          :
            <ParkServiceSelector {...{park, base, date}} />
      :
      <p>Please complete {park.workflow_name} </p>
    }
    </div>
  )
}

export default ParkReservationBlock
